module.exports = __webpack_public_path__ + "resources/img/sp_support_m.37310dba67f9518b83ecf20aae1af607.png";